import type { ReactNode } from "react";
import { themeClasses, type Theme } from "@cw/design-tokens/theme";
import { ContainedSection } from "../primitives/Section";
import { LinkRow, type LinkSpec } from "../primitives/Button";

export function CtaBand({ heading, children, links, theme = "accent", id }: { heading: string; children?: ReactNode; links?: LinkSpec[]; theme?: Theme; id?: string }) {
  const t = themeClasses(theme);
  return (
    <ContainedSection theme={theme} id={id} className="cw-cta-band">
      <div className="mx-auto max-w-3xl text-center">
        <h2 className={`${t.heading} text-display-md font-semibold`}>{heading}</h2>
        {children ? <div className={`${t.body} mt-5 text-lg`}>{children}</div> : null}
        <LinkRow links={links} theme={theme} size="lg" className="mt-9 justify-center" />
      </div>
    </ContainedSection>
  );
}
